import { IQuote } from './quote.interface';
import { IAddresses } from './user.interface';

interface IVehicleDetails {
  is_completed?: boolean;
  pre_existing_damage?: boolean;
  preferred_excess?: string;
  registered_owner?: string;
  registered_owner_title?: string;
  registered_owner_name?: string;
  registered_owner_surname?: string;
  registered_owner_id?: string;
  registered_owner_relationship?: string;
  registration_nr?: string;
  driver_licence_date_issued?: Date;
  sum_insured?: number;
  sum_insured_type?: string;
  tracking_device?: boolean;
  type_of_cover?: string;
  uninterrupted_cover?: string;
  use_of_vehicle?: string;
  used_to_carry_goods?: boolean;
  value_of_contents?: number;
  vehicle_value_type?: string;
  year_of_manufacture?: number;
  years_since_incident?: number;
  overnight_address?: IAddresses;
  overnight_address_id?: number;
  daytime_address?: IAddresses;
  daytime_address_id?: number;
  make?: string;
  model?: string;
  model_id?: string;
  modified_vehicle?: boolean;
  model_series?: string;
  model_variant?: string;
  number_claims_last_12_months?: number;
  number_claims_last_13_to_24_months?: number;
  number_claims_last_25_to_36_months?: number;
  number_incidents_last_5_years?: number;
  optional_credit_shortfall?: boolean;
  licence_type?: string;
  extras?: Array<string>;
  flat_excess?: boolean;
  date_added?: string;
  tracker_lead?: ITrackerLead;
  kp_chilli_premium_tiers?: Array<IKPChilliPremiumTier>;
  sasria?: number;
  user_id?: number;
  quote_request_id?: number;
  quote_detail?: Array<IQuote>;
}

export interface ITrackerLead {
  description?: string;
  asset_description?: string;
  id?: number;
  premium?: number;
}

export interface IKPChilliPremiumTier {
  max_km: number;
  min_km: number;
  description: string;
  difference_to_selected: number;
  level: number;
  premium: number;
  selected: boolean;
}
export interface IBuilding {
  id?: number;
  type?: string;
  is_completed?: boolean;
  address?: IAddresses;
  address_id?: number;
  claims?: Array<IPrevousClaims>;
  wall_construction?: string;
  roof_construction?: string;
  date_added?: string;
  sasria?: number;
  user_id?: number;
  quote_request_id?: number;
  quote_detail?: Array<IQuote>;
}

export interface ICaravan extends IVehicleDetails {
  id?: number;
  caravan_or_trailer?: string;
  claims_prefill?: boolean;
  finance_provider?: string;
  claims?: Array<IPrevousClaims>;
  hail_net_or_roof?: boolean;
  last_claim?: string;
  parked_on_plot_or_farm?: boolean;
  is_completed?: boolean;
}

// interface IEndorsementDetails {
//   postalCodeId?: string;
//   risk_address_line1?: string;
//   risk_address_line2?: string;
//   risk_address_line_3?: string;
//   risk_address_code?: string;
// }
// export interface IContent {
//   id?: number;
//   is_completed?: boolean;
//   address?: string;
//   building_type?: string;
//   risk_address?: IAddresses;
//   risk_address_id?: number;
//   claims?: Array<IPrevousClaims>;
//   wall_construction?: string;
//   roof_construction?: string;
//   safety_measures?: Array<string>;
//   date_added?: string; //TODO when ctrl api switch-over change this to date
//   sasria?: number;
//   premium?: number;
//   user_id?: number;
//   quote_request_id?: number;
// }

export interface IContent {
  id?: number;
  is_completed?: boolean;
  access_control_24_hour?: null | boolean;
  additional_security?: string;
  address?: IAddresses;
  address_id?: number;
  alarm_armed_response?: boolean;
  alarm_panic_button?: boolean;
  alarm_professionally_installed?: boolean;
  alarm_service_provider?: string;
  alarm_working_order?: boolean;
  below_floodline?: boolean;
  building_type?: string;
  burglar_bars?: string;
  business_use?: boolean;
  business_use_equipment?: null;
  business_use_number_clients?: null;
  business_use_number_employees?: null;
  business_use_stock_on_premises?: null;
  business_use_type?: null;
  claims?: Array<IPrevousClaims>;
  construction_to_building?: boolean;
  created_time?: null;
  ctrl_id?: string;
  electric_fence?: boolean;
  extension_accidental_damage?: string;
  extension_mech_elec_electronic_damage?: string;
  extension_power_surge?: string;
  extension_subsidence?: boolean;
  flood_dependency?: null;
  geological_report?: boolean;
  holiday_in2_months?: boolean;
  home_age?: string;
  house_type?: string;
  informal_settlement_close_by?: boolean;
  installed_alarm?: boolean;
  insurance_last36_mths?: boolean;
  interleading_door?: boolean;
  is_asset_insured?: boolean;
  is_deleted?: null;
  is_near_open_field?: boolean;
  longest_period_residence_unoccupied?: number;
  miway_object_no?: number;
  miway_policy_line_no?: number;
  modified_time?: null;
  neighbours?: boolean;
  no_claim_bonus_proof?: boolean;
  occupant_during_day?: string;
  occupant_during_night?: string;
  occupied_during_day?: boolean;
  occupied_period?: string;
  open_field_type?: null;
  optional_baboon_cover?: boolean;
  other_people_in_residence?: boolean;
  outbuilding?: boolean;
  outbuilding_size?: null;
  outbuilding_type?: null;
  perimeter_wall?: string;
  plans_approved?: boolean;
  preferred_excess?: string;
  quote_request_id?: number;
  registered_owner?: string;
  residence_hired_or_let?: boolean;
  residence_situation?: string;
  residence_unoccupied7_days_first_month?: boolean;
  residence_unoccupied_more_than60_days_first_year?: boolean;
  residence_use?: string;
  residence_vacant?: boolean;
  roof_construction?: string;
  security_cameras?: boolean;
  security_gates?: string;
  security_guard_24_hour?: null;
  sliding_doors?: boolean;
  sliding_doors_security?: boolean;
  storage_facility?: boolean;
  sum_insured?: number;
  sum_insured_jewellery?: number;
  swimming_pool?: boolean;
  thatch_lapa_safety?: null;
  thatch_lapa_size?: null;
  thatch_lapa_within3_meters?: null;
  thatch_risk?: boolean;
  type_of_cover?: string;
  type_of_excess?: string;
  user_id?: number;
  wall_construction?: string;
  within500m_from_sea_river_lake_dam?: null;
  years_contents_insurance?: string;
  sasria?: number;
  quote_detail?: Array<IQuote>;
}

export interface IMotorcycle extends IVehicleDetails {
  id?: number;
  registration_year?: number;
  make?: string;
  motorcycle_type?: string;
  odometer?: number;
  model?: string;
  use_of_motorcycle?: string;
  vin?: string;
  claims?: Array<IPrevousClaims>;
  enginge_number?: string;
  chassis_number?: string;
  regular_driver_relationship?: string;
  regular_driver_title?: '';
  regular_driver_name?: string;
  regular_driver_surname?: string;
  regular_driver_id?: string;
  sasria?: number;
  is_completed?: boolean;
}

export interface ISpecifiedItem {
  asset_detail?: ISpecifiedItem;
  id?: number;
  is_completed?: boolean;
  description?: string;
  serial_nr?: string;
  date_added?: string;
  sasria?: number;
  item?: string;
  user_id?: number;
  quote_request_id?: number;
  quote_detail?: Array<IQuote>;
}

export interface IVehicle extends IVehicleDetails {
  id?: number;
  registration_year?: number;
  vehicle_type?: string;
  odometer?: number;
  driver_licence_date_issued?: Date;
  vin?: string;
  enginge_number?: string;
  chassis_number?: string;
  make?: string;
  claims_prefill?: boolean;
  claims?: Array<IPrevousClaims>;
  colour?: string;
  daytime_parking?: string;
  driving_offence?: boolean;
  engine_number?: string;
  finance_provider?: string;
  gearlock_type?: string;
  immobiliser_type?: string;
  regular_driver_relationship?: string;
  regular_driver_title?: '';
  regular_driver_name?: string;
  regular_driver_surname?: string;
  regular_driver_id?: string;
  is_completed?: boolean;
}

export type TAsset = IVehicle | ICaravan | IBuilding | IContent | ISpecifiedItem | IAllRiskItem | IMotorcycle;

export interface IAllRiskItem {
  asset_detail?: IAllRiskItem;
  id?: number;
  item?: string;
  is_completed?: boolean;
  sum_insured?: number;
  sasria?: number;
  date_added?: string;
  user_id?: number;
  quote_request_id?: number;
  quote_detail?: Array<IQuote>;
}

export interface IAssetTypeKey {
  type: string;
  key: string;
}

export interface IGenericAsset {
  premium: number;
  sum_insured: any;
  excess: number;
}
export interface IPrevousClaims {
  id?: number;
  asset_id?: number;
  user_id?: number;
  date_full?: string;
  created_time?: string;
  modified_time?: string;
  date?: string;
  reason?: string;
  temp_id?: string;
}

export interface IDeleteAssets {
  all_risks: number[];
  buildings: number[];
  caravans: number[];
  contents: number[];
  motorcycles: number[];
  specified_items: number[];
  user_id: number;
  vehicles: number[];
}
